"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moransengo-tonengo": {
    "9396f426": [{
      "hkey": "469d8c35",
      "slug": "moransengo",
      "name": "Moransengo",
      "primary": true,
      "skipSearch": false
    }],
    "f6098b6a": [{
      "hkey": "65fbc22a",
      "slug": "valle-dei-nervo",
      "name": "Valle dei Nervo",
      "primary": true,
      "skipSearch": false
    }],
    "d07f789b": [{
      "hkey": "987c2565",
      "slug": "gerbole",
      "name": "Gerbole",
      "primary": true,
      "skipSearch": false
    }],
    "013565a1": [{
      "hkey": "ec0e1f49",
      "slug": "mariano-pareglio",
      "name": "Mariano-Pareglio",
      "primary": true,
      "skipSearch": false
    }],
    "451d1f37": [{
      "hkey": "17e9fe41",
      "slug": "tonengo",
      "name": "Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "d0a76746": [{
      "hkey": "bd413fd4",
      "slug": "cerrabello",
      "name": "Cerrabello",
      "primary": true,
      "skipSearch": false
    }],
    "df027755": [{
      "hkey": "d7a8ba10",
      "slug": "ottini",
      "name": "Ottini",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;